<template>
  <div>
    <h1>Actualizar sitio</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Sitio (adjuntar archivo .kmz)</label>
              <b-form-file
                v-model="$v.site.file.$model"
                ref="file"
                :state="fileState"
                :placeholder="kmzFile"
                browse-text="Sitio"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                accept=".KMZ"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Nombre del sitio">
                <a-input ref="name" placeholder="Nombre del sitio" v-model="$v.site.name.$model" />
                <small class="text-danger" v-if="!$v.site.name.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!validateRegisteredSite($v.site.name.$model)">Ya existe un registro con este nombre</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Tarifa adicional al banderazo">
                <a-input ref="extraStartedPrice" placeholder="Tarifa adicional al banderazo" v-model="$v.site.extraStartedPrice.$model" />
                <small class="text-danger" v-if="!$v.site.extraStartedPrice.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Restricción de inicio de viaje">
                <a-checkbox ref="restriction" v-model="restriction">
                  Restricción de inicio de viaje
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(validateRegisteredSite($v.site.name.$model) && !$v.$invalid)">
                  Actualizar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const UPDATE_SITE = gql`
  mutation updateSite($id: Int, $kmzFile: String, $name: String, $limitation: Int, $extraStartedPrice: Float){
    updateSite(id: $id updateSiteInput: { kmzFile: $kmzFile name: $name limitation: $limitation extraStartedPrice: $extraStartedPrice }){
      kmzFile
      name
      limitation
      extraStartedPrice
    }
  }
`
const GET_ALL_SITES = gql`
  query getAllSites{
    getAllSites{
      id
      name
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      site: {
        file: new File([''], this.$route.params.kmzFile.split('/').pop()),
        name: this.$route.params.name,
        extraStartedPrice: this.$route.params.extraStartedPrice,
        limitation: this.$route.params.limitation,
      },
      restriction: false,
      kmzFile: this.$route.params.kmzFile.split('/').pop(),
      fileState: null,
      registeredSites: {},
    }
  },
  apollo: {
    getAllSites: {
      query: GET_ALL_SITES,
      context: headers(),
      result({ data }) {
        console.log(data, 'data')
        data.getAllSites.forEach(site => {
          this.registeredSites[site.name] = 1
        })
        delete this.registeredSites[this.site.name]
      },
    },
  },
  created() {
    console.log(this.$route.params)
    if (this.$route.params.limitation === 1) {
      this.restriction = true
    } else {
      this.restriction = false
    }
  },
  methods: {
    async handleSubmit() {
      let location = ''
      if (this.kmzFile === this.site.file.name) {
        location = this.$route.params.kmzFile
      } else {
        const file = []
        file.fileExtension = this.site.file.name.split('.').pop()
        file.fileUploaded = this.site.file
        const uploadedFile = await uploadFileS3(file)
        location = uploadedFile.Key
      }
      if (this.restriction === true) {
        this.site.limitation = 1
      } else {
        this.site.limitation = 0
      }
      this.$apollo.mutate({
        mutation: UPDATE_SITE,
        context: headers(),
        variables: {
          id: parseInt(this.$route.params.id),
          kmzFile: location,
          name: this.site.name,
          extraStartedPrice: parseFloat(this.site.extraStartedPrice),
          limitation: parseInt(this.site.limitation),
        },
      })
        .then(data => {
          this.$router.push({ name: 'GetSites' })
        })
        .catch(error => {
          console.log(error)
        })
      // console.log(this.geofence.file)
    },
    validateRegisteredSite(name) {
      if (this.registeredSites[name.trim()]) {
        return false
      } else {
        return true
      }
    },
    disableForm() {
      this.$refs.button.disabled = true
      this.$refs.file.disabled = true
      this.$refs.name.disabled = true
      this.$refs.restriction.disabled = true
      this.$refs.extraStartedPrice.disabled = true
    },
    onFileSelected(event) {
      this.site.file = event.target.files[0]
      // console.log(event.target.files[0])
      // console.log(this.geofence.file)
    },
  },
  validations: {
    site: {
      file: { required },
      name: { required },
      extraStartedPrice: { required },
      limitation: {},
    },
  },
}
</script>
